import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getTechnologicalTransferValidationOptions,
  useValidateTechnologicalTransfer,
} from '@/module/Author/TechnologicalTransfer/Validation/model/TechnologicalTransferValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  technologicalTransferId: Id;
  variant?: ValidationVariant;
}

export function TechnologicalTransferValidationAction({ technologicalTransferId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getTechnologicalTransferValidationOptions(technologicalTransferId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateTechnologicalTransfer(technologicalTransferId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
